import { InjectionToken, WritableSignal } from '@angular/core';

export enum GbTheme {
  ThemeOne = 't1',
  ThemeTwo = 't2',
}

// InjectionToken that provides a writable signal
export const THEME_SIGNAL = new InjectionToken<WritableSignal<GbTheme>>('THEME_SIGNAL');
